import React from 'react'

const OurSolution = () => {
  return (
   <section className="lg:py-28 lg:px-12 px-4 py-12 bg-bgDefault text-white overflow-x-hidden">
      <div className="container mx-auto w-full max-w-full max-w-screen-xl overflow-hidden">
        {/* Header */}


        {/* Content Container */}
        <div className="lg:px-[168px]">
          {/* Description */}
          <h2
            className="text-3xl lg:text-4xl font-bold tracking-tight mb-6 lg:mb-8"
          >
            What We Did & How We Did It
          </h2>

          {/* <h3 className="text-2xl lg:text-3xl font-semibold text-[#00E599] mb-4">What We Did & How We Did It</h3> */}

          <p
            className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-6"
          >
            We architected and deployed a comprehensive academic EHR training platform using enterprise-grade
            technologies including Java, Spring Boot for robust backend services, Angular for an intuitive
            frontend interface, and PostgreSQL for reliable data persistence. The entire infrastructure was
            deployed on AWS with Docker containerization and Jenkins CI/CD pipelines for automated testing
            and deployment.
          </p>

          <h4
            // className="text-xl font-semibold text-white mb-3"
          >
            Core Features Delivered:
          </h4>
          <ul className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-6 list-disc pl-5 space-y-2">
            <li ><strong>Simulation Chart Creation:</strong> Faculty-facing tools to create realistic, customizable patient charts mirroring real-world clinical scenarios across diverse medical conditions</li>
            <li ><strong>Student Training Module:</strong> Hands-on environment for managing lab/radiology orders, prescriptions, demographics, and complete patient histories</li>
            <li ><strong>Online Practical Examinations:</strong> Digital examination platform enabling chart submissions, faculty review, and structured approval/rejection workflows</li>
            <li><strong>Real-Time Feedback System:</strong> Integrated commenting and guidance tools for instructors to provide targeted feedback on student submissions</li>
            <li ><strong>Spring Security Implementation:</strong> Role-based access control, encrypted data transmission, and secure authentication mechanisms</li>
            <li><strong>Scalable Architecture:</strong> Microservices-based design capable of handling 1 million+ simulated patient charts annually</li>
          </ul>

          <h2
            className="text-3xl lg:text-4xl font-bold tracking-tight mb-6 lg:mb-8 mt-8"
          >
            Results Achieved
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" >
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">10,000+</h5>
              <p className="text-[#9E9E9E]">Medical students trained in realistic EHR workflows</p>
            </div>
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" >
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">30%</h5>
              <p className="text-[#9E9E9E]">Reduction in learning curve before clinical rotations</p>
            </div>
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20">
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">5,000+</h5>
              <p className="text-[#9E9E9E]">Online practical exams conducted successfully</p>
            </div>
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" >
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">40%</h5>
              <p className="text-[#9E9E9E]">Faculty time saved compared to paper-based evaluations</p>
            </div>
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" >
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">25%</h5>
              <p className="text-[#9E9E9E]">Increase in student participation and retention rates</p>
            </div>
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" >
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">Zero</h5>
              <p className="text-[#9E9E9E]">Data breaches with full HIPAA & FERPA compliance</p>
            </div>
          </div>

          <p
            className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed"
          >
            The platform successfully transformed medical education by providing a safe, scalable, and realistic
            training environment that bridges the critical gap between theoretical knowledge and clinical practice.
            Students can now make mistakes, learn from them, and build confidence before entering real healthcare
            settings, resulting in better-prepared healthcare professionals and improved patient safety outcomes.
          </p>
        </div>
      </div>
    </section>
  )
}

export default OurSolution
